import type {
  ArticleDividerComponent,
  ArticleHeadlineComponent,
  ArticleMediaComponent,
  ArticleParagraphComponent,
  ArticleWarningBoxComponent,
} from '@twisto/api-cms'

import type { RichTextBlock } from 'homepage/components/rich-text/rich-text.d'

import { Divider, Headline, Media, Paragraph, WarningBox } from '.'

export type ComponentsType =
  | ArticleDividerComponent
  | ArticleHeadlineComponent
  | ArticleMediaComponent
  | ArticleParagraphComponent
  | ArticleWarningBoxComponent

type Props = {
  components?: ComponentsType[]
}

const ArticleComponent = ({ sectionData }: { sectionData: ComponentsType }) => {
  switch (sectionData.__component) {
    case 'article.divider':
      return <Divider />
    case 'article.headline':
      return <Headline {...sectionData} />
    case 'article.media':
      return <Media {...sectionData} />
    case 'article.paragraph':
      return (
        <Paragraph
          {...sectionData}
          text={sectionData.text as RichTextBlock[]}
        />
      )
    case 'article.warning-box':
      return (
        <WarningBox
          {...sectionData}
          content={sectionData.content as RichTextBlock[]}
        />
      )
    default:
      return null
  }
}

export const ArticleComponents = ({ components }: Props) => (
  <>
    {components?.map((component, index) => (
      <ArticleComponent
        key={`${component.__component}${index}`}
        sectionData={component}
      />
    ))}
  </>
)
